import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Title } from '@angular/platform-browser';
import { RouterOutlet } from '@angular/router';
import { SimpleNotificationsModule } from 'angular2-notifications';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    imports: [RouterOutlet, SimpleNotificationsModule],
})
export class AppComponent {
    constructor(
        private translateService: TranslateService,
        private title: Title,
    ) {
        this.title.setTitle(this.translateService.instant('Customer reply portal'));
    }
}
